enum MessageStatus {
  InProgress = 0,
  Sent = 1,
  Delivered = 2,
  Read = 3,
  Failed = 4,
}

enum SenderType {
  Client = 0,
  Admin = 1,
  Operator = 2
}

interface Message {
  Id: string,
  Text: string,
  Status: MessageStatus,
  Attachments: AttachmentData[] | null,
  AttachmentPackage: AttachmentPackage,
  SenderType: SenderType,
  CreatedAt: Date
}

interface AttachmentData {
  Name: string,
  Path: string,
  Type: string,
  Content: ArrayBuffer
}

interface AttachmentPackage {
  Id: string,
  Name: string,
  Description: string,
  AttachmentsCount: number,
  CreatedAt: any | Date,
  UpdatedAt: any | Date
}

type MessageDataPayload = {
  ClientId: any,
}

export { Message, AttachmentData, AttachmentPackage, MessageStatus, MessageDataPayload, SenderType }